import React, { useState, FormEvent, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, Classes, MenuItem, Alert, Spinner } from "@blueprintjs/core";

import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';

import { Account, Currency, NumData, Environment, Cash, CashItem, Vendor, Customer, Receivable } from './Types'


interface ReceiptViewProps {
    svc: AxiosInstance,
    currentEnv: Environment,
    ch: Cash,
    baseUrl?: string,
    token?: string | null,
    onNew?: () => void,
    onEdit?: () => void,
    onCopy?: () => void,
    onDelete?: (ch: Cash) => void,
}

function ReceiptView({ svc, currentEnv, ch = {} as Cash, baseUrl = "", token = "", onNew = () => {}, onEdit = () => { }, onCopy = () => { }, onDelete = () => { } }: ReceiptViewProps) {
    const { t, i18n } = useTranslation();
    const [isOpenDelete, setIsOpenDelete] = useState(false)

    if (!("voucherCode" in ch)) return null

    let totalDr = ch.dr, totalCr = ch.cr
    for (const item of ch.items) {
        totalDr += item.dr
        totalCr += item.cr
    }

    return (
        <div>
            {/*
            <Dialog icon="help" isOpen={isOpenDelete} canEscapeKeyClose={true} canOutsideClickClose={true} title="AC3x" onClose={() => setIsOpenDelete(false)}>
                <div className="DialogBody">
                    <div className="Spacing-V-16" />
                    <p>Delete voucher {ch.voucherCode}?</p>
                    <div className="Row-4">
                        <Button className="Col-3-1" icon="cross" onClick={() => setIsOpenDelete(false)}>No</Button>
                        <Button className="Col-4-1" icon="tick" intent="danger" onClick={() => {onDelete(ch); setIsOpenDelete(false)}}>DELETE</Button>
                    </div>
                </div>
            </Dialog>
            */}
            <Alert icon="trash" intent="danger" confirmButtonText={t('button_delete')} isOpen={isOpenDelete} onConfirm={() => {onDelete(ch); setIsOpenDelete(false)}} onCancel={() => setIsOpenDelete(false)} cancelButtonText={t('button_no')} canEscapeKeyCancel={true} canOutsideClickCancel={true}>
                <p>{t('confirm_delete_ch', {ch})}</p>
            </Alert>
            <div className="Row">
                <Button className="Col-1-1" icon="add" onClick={() => onNew()}>{t('new')}</Button>
                <Button className="Col-2-1" icon="edit" onClick={() => onEdit()}>{t('edit')}</Button>
                <Button className="Col-3-1" icon="duplicate" onClick={() => onCopy()}>{t('make_copy')}</Button>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('journal')}>
                    <InputGroup readOnly value={ch.journalCode} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('voucher')}>
                    <InputGroup readOnly value={ch.voucherCode} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('reference')}>
                    <InputGroup readOnly value={ch.reference} />
                </FormGroup>
                <FormGroup className="Col-4-1" label={t('date')}>
                    <InputGroup readOnly value={ch.txDate} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('party_type')}>
                    <InputGroup readOnly value={t(utils.partyTypeName(ch.partyType))} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('party_code')}>
                    <InputGroup readOnly value={ch.partyCode} />
                </FormGroup>
                <FormGroup className="Col-3-2" label={t('party_name')}>
                    <InputGroup readOnly value={ch.partyName} />
                </FormGroup>
            </div>
            {/*
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('amount')}>
                    <InputGroup readOnly value={utils.formatMoney(ch.amount)} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('cheque_no')}>
                    <InputGroup readOnly value={ch.cheque} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('account')}>
                    <InputGroup readOnly value={ch.acCode} />
                </FormGroup>
                <FormGroup className="Col-4-2" label={t('account_name')}>
                    <InputGroup readOnly value={ch.acName} />
                </FormGroup>
            </div>
            */}
            <HTMLTable striped interactive condensed>
            <thead>
                <tr>
                    <th className="TCol-ChequeNo">{t('cheque_or_invoice')}</th>
                    {/*<th className="TCol-Reference">{t('reference')}</th>*/}
                    <th className="TCol-ACCode">{t('account')}</th>
                    <th className="TCol-ACName">{t('account_name')}</th>
                    <th className="TCol-ACBalance"><div className="Align-R">{t('dr')}</div></th>
                    <th className="TCol-ACBalance"><div className="Align-R">{t('cr')}</div></th>
                </tr>
            </thead>
            <tbody>
                <tr key={0}>
                    <td className="TCol-ChequeNo">{ch.cheque}</td>
                    {/*<td className="TCol-Reference">{ch.reference}</td>*/}
                    <td className="TCol-ACCode">{ch.acCode}</td>
                    <td className="TCol-ACName">{ch.acName}</td>
                    <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(ch.dr)}</div></td>
                    <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(ch.cr)}</div></td>
                </tr>
                {ch.items.map((item, i) =>
                    <tr key={i+1}>
                        <td className="TCol-InvoiceNo">{item.invNo}</td>
                        {/*<td className="TCol-Reference">{item.reference}</td>*/}
                        <td className="TCol-ACCode">{item.acCode}</td>
                        <td className="TCol-ACName">{item.acName}</td>
                        <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(item.dr)}</div></td>
                        <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(item.cr)}</div></td>
                    </tr>
                )}
            </tbody>
            <tfoot>
                <tr>
                <td className="TCol-ChequeNo"></td>
                {/*<td className="TCol-Reference"></td>*/}
                <td className="TCol-ACCode"></td>
                <td className="TCol-ACName"></td>
                <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalDr)}</b></div></td>
                <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalCr)}</b></div></td>
                </tr>
            </tfoot>
            </HTMLTable>
            <div className="Spacing-V-16" />
            <div className="Row">
                <Button className="Col-1-1" icon="trash" onClick={() => setIsOpenDelete(!isOpenDelete)}>{t('delete')}</Button>
            </div>
        </div>
    )
}

interface ReceiptEditProps {
    svc: AxiosInstance,
    currentEnv: Environment,
    ch?: Cash,
    ccyList?: Currency[],
    acList?: Account[],
    numList?: NumData[],
    isNew?: boolean,
    onSave: (ch: Cash, saveAndNew: boolean) => Promise<boolean>,
    onCancel: () => void,
}

function ReceiptEdit({ svc, currentEnv, ch = {} as Cash, ccyList = [] as Currency[], acList = [] as Account[], numList = [] as NumData[], isNew = false, onSave, onCancel }: ReceiptEditProps) {
    const { t, i18n } = useTranslation();
    const { register, handleSubmit, reset, setValue, getValues } = useForm<Cash>()

    const defaultItems = "voucherCode" in ch ? ch.items : [{} as CashItem]
    const [items, setItems] = useState(defaultItems)
    const [partyType, setPartyType] = useState("C")
    const defaultCustCode = "partyCode" in ch && ch.partyType === "C" ? ch.partyCode : ""
    const [custCode, setCustCode] = useState(defaultCustCode)
    const [vendList, setVendList] = useState([] as Vendor[])
    const [custList, setCustList] = useState([] as Customer[])
    const [arList, setArList] = useState([] as Receivable[])
    const defaultAcBank = "voucherCode" in ch ? {acCode: ch.acCode, acName1: ch.acName} as Account : {}
    const [acBank, setAcBank] = useState(defaultAcBank as Account)
    const defaultCust = "voucherCode" in ch ? {custCode: ch.partyCode, custName: ch.partyName} as Customer : {}
    const [currentCust, setCurrentCust] = useState(defaultCust as Customer)
    const defaultVend = "voucherCode" in ch ? {vendCode: ch.partyCode, vendName: ch.partyName} as Vendor : {}
    const [currentVend, setCurrentVend] = useState(defaultCust as Vendor)
    const [totalDr, setTotalDr] = useState(0)
    const [totalCr, setTotalCr] = useState(0)

    const onFormChange = () => recalcTotals()
    const recalcTotals = () => {
        let sumDr = 0, sumCr = 0
        sumDr += utils.StringToNum(getValues(`dr`))
        sumCr += utils.StringToNum(getValues(`cr`))
        for (let i = 0; i < items.length; i++) {
            sumDr += utils.StringToNum(getValues(`items[${i}].dr`))
            sumCr += utils.StringToNum(getValues(`items[${i}].cr`))
        }
        setTotalDr(sumDr)
        setTotalCr(sumCr)
    }

    const refreshVendList = async () => {
        if ("envId" in currentEnv) {
            const res = await svc.post('/vendorlist');
            //console.log("refreshVendList", res.data.data)
            setVendList(res.data.data)
        }
    }
    const refreshCustList = async () => {
        if ("envId" in currentEnv) {
            const res = await svc.post('/customerlist');
            //console.log("refreshCustList", res.data.data)
            setCustList(res.data.data)
        }
    }

    const refreshArList = async () => {
        if ("envId" in currentEnv && custCode !== "" ) {
            const res = await svc.post('/arlist',
            {
                by: "custCode",
                start: custCode,
                includesPaid: false,
            });
            console.log("refreshArList", res.data.data)
            setArList(res.data.data)
        }
    }

    /*
    useEffect(() => {
        console.log("useEffect [vendList]")
    }, [vendList])
    */

    useEffect(() => {
        console.log("useEffect [custCode, currentEnv]")
        refreshArList()
    }, [custCode, currentEnv])

    useEffect(() => {
        console.log("useEffect [currentEnv]")
        refreshVendList()
        refreshCustList()
    }, [currentEnv])

    useEffect(() => {
        // Call reset to set default values if ch is passed
        //console.log("useEffect ch, reset, setValue, isNew")
        console.log("useEffect []", `isNew=${isNew}`)
        if ("voucherCode" in ch) {
            if (isNew) {
                // default values for new/copied record
                reset({...ch, ...{voucherCode: "", txDate: utils.formatDate(new Date()), cheque: "", reference: ""}})
            } else {
                reset(ch)
            }
        }
        recalcTotals()
        /*
        console.log("register fields")
        //register({ name: "ccyCode" })
        //register({ name: "journalCode" })
        register({ name: "txType" })
        register({ name: "partyType" })
        register({ name: "partyCode" })
        register({ name: "acCode" })
        items.map((item, i) => {register({ name: `items[${i}].invNo`});return null})
        items.map((item, i) => {register({ name: `items[${i}].acCode`});return null})

        if (isNew) {
            console.log("set default values")
            //setValue("journalCode", "CH")
            setValue("txType", "D")
            setValue("txDate", utils.formatDate(new Date()))
            setValue("partyType", "C")
        }
        */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    //}, [ch, reset, setValue, isNew])

    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        console.log("useEffect [register]")
        //register({ name: "ccyCode" })
        //register({ name: "journalCode" })
        register({ name: "txType" })
        register({ name: "partyType" })
        register({ name: "partyCode" })
        register({ name: "acCode" })
        items.map((item, i) => {register({ name: `items[${i}].invNo`});return null})
        items.map((item, i) => {register({ name: `items[${i}].acCode`});return null})
        console.log("register fields")

        if (isNew) {
            console.log("set default values")
            //setValue("journalCode", "CH")
            setValue("txType", "D")
            setValue("txDate", utils.formatDate(new Date()))
            setValue("partyType", "C")
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [register])

    if (!isNew && !("voucherCode" in ch)) return null

    //const onSubmitAndNew = (data: Cash) => preSave(data, true)
    //const onSubmit = (data: Cash) => preSave(data, false)
    //const preSave = async (data: Cash, saveAndNew: boolean = false) => {
    const onSubmit = async (data: Cash) => {
        //data.dr = 0
        //data.cr = 0
        console.log(Object.assign(data))
        for (let i = data.items.length-1; i >= 0; i--) {
            //console.log(i, data.items[i] && data.items[i].acCode)
            if (data.items[i] === undefined ||
                data.items[i].acCode === "" ||
                (data.items[i].acCode !== "C" && (data.items[i].dr - data.items[i].cr) === 0) ||
                (data.items[i].acCode === "C" && data.items[i].reference === ""  && (data.items[i].dr - data.items[i].cr) === 0)) {
                //console.log("deleting", i)
                data.items.splice(i, 1)
            } else {
                //data.dr += Number(data.items[i].dr)
                //data.cr += Number(data.items[i].cr)
            }
        }
        //console.log("onsubmit called", data)
        let saveAndNew = isNew
        if (await onSave(data, saveAndNew) && saveAndNew) {
            //console.log("saveAndNew resetting form")
            setItems([{} as CashItem])
            setCurrentCust({} as Customer)
            setCurrentVend({} as Vendor)
            setAcBank({} as Account)
            reset({
                journalCode: data.journalCode,
                voucherCode: "",
                txType:"D",
                partyType:"C",
                txDate: utils.formatDate(new Date()),
                cheque: "",
                acCode: "",
                acName: "",
                dr: 0,
                cr: 0,
                reference: "",
                items: [{acName: ""}],
            })
            recalcTotals()
            document.getElementsByName(`voucherCode`)[0].focus()
        }
    }

    const onAdd = () => {
        register({ name: `items[${items.length}].invNo`})
        register({ name: `items[${items.length}].acCode`})
        //console.log("register", { name: `items[${items.length}].acCode`})
        setItems(items.concat({} as CashItem))
    }

    const acRenderer: ItemRenderer<Account> = (ac, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        //const text = `${ac.acCode} - ${ac.acName1}`;
        const text = `${ac.acCode} ${ac.acName1.length > 0 || ac.acName2.length > 0 ? '-' : ''} ${ac.acName1+ac.acName2}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={ac.acCode}
                key={ac.acCode}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const acPredicate: ItemPredicate<Account> = (query, ac, _index, exactMatch) => {
        const normalizedText = `${ac.acCode} - ${ac.acName1+ac.acName2}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const acValueRenderer = (ac: Account) => {
        return ac.acCode
    }

    const vendRenderer: ItemRenderer<Vendor> = (vend, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${vend.vendCode} - ${vend.vendName}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={vend.vendCode}
                key={vend.vendCode}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const vendPredicate: ItemPredicate<Vendor> = (query, vend, _index, exactMatch) => {
        const normalizedText = `${vend.vendCode} - ${vend.vendName}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const vendValueRenderer = (vend: Vendor) => {
        return vend.vendCode
    }

    const custRenderer: ItemRenderer<Customer> = (cust, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${cust.custCode} - ${cust.custName}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={cust.custCode}
                key={cust.custCode}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const custPredicate: ItemPredicate<Customer> = (query, cust, _index, exactMatch) => {
        const normalizedText = `${cust.custCode} - ${cust.custName}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const custValueRenderer = (cust: Customer) => {
        return cust.custCode
    }

    const arRenderer: ItemRenderer<Receivable> = (ar, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${ar.invNo} - ${ar.invDate} - ${utils.formatMoney(Math.abs(ar.outstanding))}`;
        return (
            <MenuItem className="bp3-monospace-text"
                active={modifiers.active}
                disabled={modifiers.disabled}
                //label={ar.invNo}
                key={ar.invNo}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const arPredicate: ItemPredicate<Receivable> = (query, ar, _index, exactMatch) => {
        const normalizedText = `${ar.invNo} - ${ar.invDate} - ${utils.formatMoney(Math.abs(ar.outstanding))}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const arValueRenderer = (ar: Receivable) => {
        return ar.invNo
    }

    const createArDataFromQuery = (query: string) => {
        return {invDate: "", invNo: query.toUpperCase(), outstanding: 0} as Receivable
    }

    const createArDataRenderer = (
        query: string,
        active: boolean,
        handleClick: React.MouseEventHandler<HTMLElement>,
    ) => (
        <MenuItem
            icon="add"
            text={`Create "${query}"`}
            active={active}
            onClick={handleClick}
            shouldDismissPopover={false}
        />
    );

    const numRenderer: ItemRenderer<NumData> = (num, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${num.group}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={num.group}
                key={num.group}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const numPredicate: ItemPredicate<NumData> = (query, num, _index, exactMatch) => {
        const normalizedText = `${num.group}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const numValueRenderer = (num: NumData) => {
        return num.group
    }

    const createNumDataFromQuery = (query: string) => {
        return {type: "J", group: query.toUpperCase(), last: 0} as NumData
    }

    const createNumDataRenderer = (
        query: string,
        active: boolean,
        handleClick: React.MouseEventHandler<HTMLElement>,
    ) => (
        <MenuItem
            icon="add"
            text={`Create "${query}"`}
            active={active}
            onClick={handleClick}
            shouldDismissPopover={false}
        />
    );

    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            //handleSubmit(onSubmitAndNew)()
            handleSubmit(onSubmit)()
        }
    }


    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey} onChange={onFormChange}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>{t('cancel')}</Button>
                {/*!isNew && <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>{t('save')}</Button>*/}
                {/*isNew && <Button className="Col-2-1" icon="add" onClick={handleSubmit(onSubmitAndNew)}>{t('save')}</Button>*/}
                <Button className="Col-2-1" icon={isNew?"add":"tick"} onClick={handleSubmit(onSubmit)}>{t('save')}</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ch)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('journal')} labelFor="inputJournalCode">
                    {/*
                    {isNew && <Suggest
                        inputProps={{ placeholder: "" }}
                        items={numList}
                        itemRenderer={numRenderer}
                        itemPredicate={numPredicate}
                        inputValueRenderer={numValueRenderer}
                        createNewItemFromQuery={createNumDataFromQuery}
                        createNewItemRenderer={createNumDataRenderer}
                        resetOnClose={true}
                        onItemSelect={(num) => {
                            setValue(`journalCode`, num.group)
                        }}
                    />}
                    {!isNew && <InputGroup readOnly defaultValue={ch.journalCode} />}
                    */}
                    <InputGroup readOnly name="journalCode" defaultValue="CH" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('voucher')} labelFor="inputCashCode">
                    <InputGroup readOnly={!isNew} id="inputCashCode" name="voucherCode" placeholder={t('auto_generated')} defaultValue={ch.voucherCode} inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('reference')} labelFor="inputReference">
                    <InputGroup id="inputReference" name="reference" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-4-1" label={t('date')} labelFor="inputTxDate">
                    <InputGroup id="inputTxDate" name="txDate" type="date" inputRef={register} />
                </FormGroup>
            </div>
            {/*
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('invoice_no')} labelFor="inputInvoiceNo">
                    <InputGroup id="inputInvoiceNo" name="invNo" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('invoice_date')} labelFor="inputInvoiceDate">
                    <InputGroup id="inputInvoiceDate" name="invDate" type="date" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('due_date')} labelFor="inputDueDate">
                    <InputGroup id="inputDueDate" name="dueDate" type="date" inputRef={register} />
                </FormGroup>
            </div>
            */}
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('party_type')} labelFor="inputPartyType">
                    {/*<InputGroup id="inputCashFlowType" name="cashFlowType" inputRef={register} />*/}
                    <HTMLSelect fill defaultValue={ch.partyType} onChange={(e) => {setValue("partyType", e.currentTarget.value); setPartyType(e.currentTarget.value); setCustCode("")}}>
                        <option value="C" selected>{t('customer')}</option>
                        <option value="V">{t('vendor')}</option>
                    </HTMLSelect>
                </FormGroup>
                {partyType === 'V' && <>
                <FormGroup className="Col-2-1" label={t('vendor_code')} labelFor="inputVendCode">
                    {/*<InputGroup id="inputVendCode" name="vendCode" inputRef={register} />*/}
                    <Suggest
                        inputProps={{ placeholder: "" }}
                        //defaultSelectedItem={{vendCode: ch.partyCode, vendName: ch.partyName} as Vendor}
                        selectedItem={currentVend}
                        items={vendList}
                        itemRenderer={vendRenderer}
                        itemPredicate={vendPredicate}
                        inputValueRenderer={vendValueRenderer}
                        resetOnClose={true}
                        onItemSelect={(vend) => {
                            //setVendCode(vend.vendCode)
                            setCurrentVend(vend)
                            setValue('partyCode', vend.vendCode)
                            setValue('partyName', vend.vendName)
                            let ac = acList.find((ac) => ac.acCode === currentEnv.acBank)
                            if (ac) {
                                setAcBank(ac)
                                setValue('acCode', ac.acCode)
                                setValue(`acName`, ac.acName1+ac.acName2)
                            }
                            //document.getElementsByName(`description`)[0].focus()
                        }}
                    />
                </FormGroup>
                <FormGroup className="Col-3-2" label={t('vendor_name')} labelFor="inputVendName">
                    <InputGroup readOnly id="inputVendName" name="partyName" inputRef={register} />
                </FormGroup>
                </>}
                {partyType === 'C' && <>
                <FormGroup className="Col-2-1" label={t('customer_code')} labelFor="inputCustCode">
                    {/*<InputGroup id="inputVendCode" name="vendCode" inputRef={register} />*/}
                    <Suggest
                        inputProps={{ placeholder: "" }}
                        //defaultSelectedItem={{custCode: ch.partyCode, custName: ch.partyName} as Customer}
                        selectedItem={currentCust}
                        items={custList}
                        itemRenderer={custRenderer}
                        itemPredicate={custPredicate}
                        inputValueRenderer={custValueRenderer}
                        resetOnClose={true}
                        onItemSelect={(cust) => {
                            setCurrentCust(cust)
                            setCustCode(cust.custCode)
                            setValue('partyCode', cust.custCode)
                            setValue('partyName', cust.custName)
                            let ac = acList.find((ac) => ac.acCode === currentEnv.acBank)
                            if (ac) {
                                setAcBank(ac)
                                setValue('acCode', ac.acCode)
                                setValue(`acName`, ac.acName1+ac.acName2)
                            }
                            document.getElementsByName(`cheque`)[0].focus()
                        }}
                    />
                </FormGroup>
                <FormGroup className="Col-3-2" label={t('customer_name')} labelFor="inputCustName">
                    <InputGroup readOnly id="inputCustName" name="partyName" inputRef={register} />
                </FormGroup>
                </>}
                <Button className="Col-5-1 Button-LabeledFormGroup" icon="add" onClick={onAdd}>{t('add_entry')}</Button>
            </div>
            <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-ChequeNo">{t('cheque_or_invoice')}</th>
                {/*<th className="TCol-Reference">{t('reference')}</th>*/}
                <th className="TCol-ACCode">{t('account')}</th>
                <th className="TCol-ACName">{t('account_name')}</th>
                <th className="TCol-ACBalance"><div className="Align-R">{t('dr')}</div></th>
                <th className="TCol-ACBalance"><div className="Align-R">{t('cr')}</div></th>
            </thead>
            <tbody>
                    <tr>
                        <td className="TCol-ChequeNo"><InputGroup id="inputCheque" name={`cheque`} placeholder={t('cheque_no')} defaultValue={ch.cheque} inputRef={register} /></td>
                        {/*<td className="TCol-Reference"><InputGroup id="inputReference" name={`reference`} inputRef={register} /></td>*/}
                        {/*<td className="TCol-ACCode"><InputGroup id="inputAcCode" name={`items[${i}].acCode`} inputRef={register} /></td>*/}
                        <td className="TCol-ACCode">
                            <Suggest
                                inputProps={{ placeholder: "" }}
                                //defaultSelectedItem={acList.find((ac) => ac.acCode === ch.acCode)}
                                selectedItem={acBank}
                                items={acList}
                                itemRenderer={acRenderer}
                                itemPredicate={acPredicate}
                                inputValueRenderer={acValueRenderer}
                                resetOnClose={true}
                                onItemSelect={(ac) => {
                                    setAcBank(ac)
                                    setValue(`acCode`, ac.acCode)
                                    //console.log("setValue", `items[${i}].acCode`, ac.acCode)
                                    setValue(`acName`, ac.acName1+ac.acName2)
                                    //console.log("newItems", newItems)
                                    document.getElementsByName(`dr`)[0].focus()
                                }}
                            />
                        </td>
                        <td className="TCol-ACName"><InputGroup readOnly id="inputAcName" name={`acName`} value={ch.acName} inputRef={register} /></td>
                        <td className="TCol-ACBalance"><InputGroup id="inputDr" name={`dr`} defaultValue={utils.numToString(ch.dr)} type="number" inputRef={register} /></td>
                        <td className="TCol-ACBalance"><InputGroup id="inputCr" name={`cr`} defaultValue={utils.numToString(ch.cr)} type="number" inputRef={register} /></td>
                    </tr>
                {items.map((item, i) =>
                    <tr>
                        {/*<td className="TCol-InvoiceNo"><InputGroup id="inputInvNo" name={`items[${i}].invNo`} inputRef={register} /></td>*/}
                        <td className="TCol-InvoiceNo">
                            <Suggest
                                inputProps={{ placeholder: "" }}
                                //defaultSelectedItem={apList.find((ap) => ap.invNo === item.invNo)}
                                selectedItem={{invNo: item.invNo} as Receivable}
                                items={arList}
                                itemRenderer={arRenderer}
                                itemPredicate={arPredicate}
                                inputValueRenderer={arValueRenderer}
                                createNewItemFromQuery={createArDataFromQuery}
                                createNewItemRenderer={createArDataRenderer}
                                resetOnClose={true}
                                onItemSelect={(ar) => {
                                    console.log(`items[${i}].invNo`,  ar.invNo)
                                    setValue(`items[${i}].invNo`, ar.invNo)
                                    setValue(`items[${i}].acCode`, ar.acCode)
                                    setValue(`items[${i}].acName`, ar.acName)
                                    setValue(`items[${i}].cr`, Math.min(ar.outstanding, getValues('dr')))
                                    recalcTotals()

                                    let newItems = Array.from(items)
                                    newItems[i].invNo = ar.invNo
                                    newItems[i].acCode = ar.acCode
                                    newItems[i].acName = ar.acName
                                    //console.log("newItems", newItems)
                                    setItems(newItems)
                                    document.getElementsByName(`items[${i}].acCode`)[0].focus()
                                }}
                            />
                        </td>
                        {/*<td className="TCol-Reference"><InputGroup id="inputReference" name={`items[${i}].reference`} inputRef={register} /></td>*/}
                        {/*<td className="TCol-ACCode"><InputGroup id="inputAcCode" name={`items[${i}].acCode`} inputRef={register} /></td>*/}
                        <td className="TCol-ACCode">
                            <Suggest
                                inputProps={{ placeholder: "", name: `items[${i}].acCode` }}
                                //defaultSelectedItem={acList.find((ac) => ac.acCode === item.acCode)}
                                selectedItem={{acCode: item.acCode, acName1: item.acName} as Account}
                                items={acList}
                                itemRenderer={acRenderer}
                                itemPredicate={acPredicate}
                                inputValueRenderer={acValueRenderer}
                                resetOnClose={true}
                                onItemSelect={(ac) => {
                                    setValue(`items[${i}].acCode`, ac.acCode)
                                    //console.log("setValue", `items[${i}].acCode`, ac.acCode)
                                    let newItems = Array.from(items)
                                    newItems[i].acCode = ac.acCode
                                    newItems[i].acName = ac.acName1+ac.acName2
                                    //console.log("newItems", newItems)
                                    setItems(newItems)
                                    document.getElementsByName(`items[${i}].cr`)[0].focus()
                                }}
                            />
                        </td>
                        <td className="TCol-ACName"><InputGroup readOnly id="inputAcName" name={`items[${i}].acName`} value={items[i].acName} inputRef={register} /></td>
                        {/*<td className="TCol-ACName"><InputGroup readOnly id="inputAcName" name={`items[${i}].acName`} inputRef={register} /></td>*/}
                        {/*
                        <td className="TCol-Desc">
                            <InputGroup id="inputDesc" name={`items[${i}].description`} inputRef={register}
                                onKeyDown={
                                    (e: React.KeyboardEvent<HTMLInputElement>) => {
                                        // ctrl + shift + " (Excel copy above cell)
                                        if (e.ctrlKey && e.shiftKey && e.keyCode === 222) {
                                            e.preventDefault()
                                            setValue(`items[${i}].description`, getValues(`items[${i-1}].description`))
                                        }
                                    }
                                }
                                rightElement={
                                    i > 0 ?
                                        <Button icon="chevron-up" minimal onClick={() => {setValue(`items[${i}].description`, getValues(`items[${i-1}].description`))}}></Button> :
                                        <Button icon="chevron-up" minimal onClick={() => {setValue(`items[${i}].description`, getValues(`description`))}}></Button>
                                }
                            />
                        </td>
                        */}
                        <td className="TCol-ACBalance"><InputGroup id="inputDr" name={`items[${i}].dr`} type="number" inputRef={register} /></td>
                        <td className="TCol-ACBalance"><InputGroup id="inputCr" name={`items[${i}].cr`} type="number" inputRef={register} /></td>
                    </tr>
                )}
            </tbody>
            <tfoot>
                <tr>
                    <td className="TCol-ChequeNo"></td>
                    {/*<td className="TCol-Reference"></td>*/}
                    <td className="TCol-ACCode"></td>
                    <td className="TCol-ACName"></td>
                    <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalDr)}</b></div></td>
                    <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalCr)}</b></div></td>
                </tr>
            </tfoot>
            </HTMLTable>
        </form>
    )
}

interface ReceiptMainProps {
    svc: AxiosInstance,
    currentEnv: Environment,
}

/*
const toaster = Toaster.create({
    position: Position.TOP,
})
*/

function ReceiptMain({ svc, currentEnv = {} as Environment }: ReceiptMainProps) {
    let { tabId: defaultTabId = "list", journalCode: defaultJournalCode, voucherCode: defaultCashCode }: { tabId: string, journalCode: string, voucherCode: string } = useParams()
    const { t, i18n } = useTranslation();
    const history = useHistory()

    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState([] as Cash[])

    const [ccyList, setCcyList] = useState([] as Currency[])
    const [acList, setAcList] = useState([] as Account[])
    const [numList, setNumList] = useState([] as NumData[])

    const [searchKey, setSearchKey] = useState("journalCode")
    const [searchValue, setSearchValue] = useState("CH")
    const [searchValue2, setSearchValue2] = useState("")

    const [showFilters, setShowFilters] = useState(true)

    let date = new Date(), y = date.getFullYear(), m = date.getMonth()
    const [searchFrom, setSearchFrom] = useState(utils.formatDate(new Date(y, m-1, 1)))
    const [searchTo, setSearchTo] = useState(utils.formatDate(date))

    const [searchReference, setSearchReference] = useState("")
    const [searchParty, setSearchParty] = useState("")
    const [searchDesc, setSearchDesc] = useState("")

    const [searchLimit, setSearchLimit] = useState(0)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [lastTabId, setLastTabId] = useState("list")
    const [currentCH, setCurrentCH] = useState({} as Cash)

    const [currentMode, setCurrentMode] = useState("show")

    useEffect(() => {
        console.log("useEffect [defaultJournalCode, defaultCashCode]")
        if ("envId" in currentEnv && defaultJournalCode && defaultCashCode) {
            console.log("show", defaultJournalCode, defaultCashCode);
            (async () => {
                try {
                    const res = await svc.post('/chlist',
                        {
                            by: "journalCode",
                            start: defaultJournalCode,
                            voucherCode: defaultCashCode,
                            limit: 1,
                        });
        
                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentCH(res.data.data[0])
                    } else {
                        utils.showError(t('no_record'))
                    }
                    //changeTab("list")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        } else {
            //console.log("not show", defaultJournalCode, defaultCashCode);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultJournalCode, defaultCashCode, svc, currentEnv])

    useEffect(() => {
        setSelectedTabId(defaultTabId)
    }, [defaultTabId])

    const changeTab = (tabId: string) => {
        history.push(`/receipts/${tabId}`)
        setSelectedTabId(tabId)
    }

    /*
    useEffect(() => {
        setSearchFrom(utils.formatDate(new Date(currentEnv.startOfYear)))
        setSearchTo(utils.formatDateMin(new Date(), new Date(currentEnv.endOfYear)))
    }, [currentEnv])
    */

    const refreshNumList = async () => {
        const res = await svc.post('/numlist',
            {
                type: "J",
            });
        setNumList(res.data.data)
    }

    useEffect(() => {
        console.log("useEffect [svc, currentEnv]");
        (async () => {
            try {
                /*
                {
                    const res = await svc.post('/getdates',
                        {});
                    setSearchFrom(res.data.data.startOfYear)
                    setSearchTo(utils.formatDate(new Date()))
                }
                */
                if ("envId" in currentEnv) {
                    refreshNumList()
                    /*
                    const res = await svc.post('/numlist',
                        {
                            type: "J",
                        });
                    setNumList(res.data.data)
                    */
                }
                {
                    const res = await svc.post('/currencylist',
                        {
                            by: "ccyCode",
                            start: "",
                            limit: 0,
                            backward: false,
                            filters: {
                                ccyCode: "",
                            }
                        });
                    setCcyList(res.data.data)
                }
                if ("envId" in currentEnv) {
                    const res = await svc.post('/accountlist',
                        {
                            by: "acCode",
                            start: "",
                            limit: 0,
                            backward: false,
                            filters: {
                                isDetailOnly: true,
                            }
                        });

                    setAcList([{acCode: "C", acName1:"", acName2:""} as Account].concat(res.data.data))
                    //setAcList(res.data.data)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [svc, currentEnv])

    /*
    useEffect(() => {
        (async () => {
            try {
                const res = await svc.post('/currencylist',
                    {
                        by: "ccyCode",
                        start: "",
                        limit: 0,
                        backward: false,
                        filters: {
                            ccyCode: "",
                        }
                    });
                setCcyList(res.data.data)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [svc])
    */

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()
        try {
            setIsLoading(true)
            const res = await svc.post('/chlist',
                {
                    by: searchKey,
                    start: searchValue,
                    voucherCode: searchValue2,
                    limit: searchLimit,
                    backward: searchBackward,
                    filters: {
                        from: searchFrom,
                        to: searchTo,
                        party: searchParty,
                        reference: searchReference,
                        desc: searchDesc,
                        type: "R",
                    }
                });

            setIsLoading(false)
            setData(res.data.data)
            if (res.data.data.length > 0) {
                setCurrentCH(res.data.data[0])
            } else {
                utils.showError(t('no_record'))
            }
            //changeTab("list")
        } catch (error) {
            utils.showError(error)
        }
    }

    const editOnSave = async (ch: Cash) => {
        try {
            const res = await svc.post('/chupdate', ch)
            utils.showSuccess(t('saved', {key: res.data.data.journalCode+' '+res.data.data.voucherCode}))
            for (let i = 0; i < data.length; i++) {
                if (data[i].journalCode === res.data.data.journalCode && data[i].voucherCode === res.data.data.voucherCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentCH(res.data.data)
            setCurrentMode("show")
            refreshNumList()
            return true
        } catch (error) {
            utils.showError(error)
            return false
        }
    }

    const newOnSave = async (ch: Cash, saveAndNew: boolean) => {
        try {
            const res = await svc.post('/chadd', ch)
            utils.showSuccess(t('saved', {key: res.data.data.journalCode+' '+res.data.data.voucherCode}))
            setCurrentCH(res.data.data)
            setData(data.concat(res.data.data))
            if (!saveAndNew) setCurrentMode("show")
            refreshNumList()
            return true
        } catch (error) {
            utils.showError(error)
            return false
        }
    }

    const viewOnDelete = async (ch: Cash) => {
        try {
            //console.log("deleting voucher:", ch)
            const res = await svc.post('/chdelete', ch)
            utils.showSuccess(t('deleted'))
            setData(data.filter(v => !(v.journalCode === res.data.journalCode && v.voucherCode === res.data.voucherCode)))
            setCurrentCH({} as Cash)
            changeTab("list")
        } catch (error) {
            utils.showError(error)
        }
    }

    // currentMode = show
    let detail = <ReceiptView svc={svc} currentEnv={currentEnv} ch={currentCH} baseUrl={svc.defaults.baseURL} token={localStorage.getItem('token')} onNew={() => {setLastTabId(selectedTabId); setCurrentMode("new")}} onEdit={() => setCurrentMode("edit")} onCopy={() => setCurrentMode("copy")} onDelete={viewOnDelete}></ReceiptView>
    switch (currentMode) {
        case "edit":
            detail = <ReceiptEdit svc={svc} currentEnv={currentEnv} ch={currentCH} ccyList={ccyList} acList={acList} numList={numList} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></ReceiptEdit>
            break
        case "new":
            detail = <ReceiptEdit isNew svc={svc} currentEnv={currentEnv} ccyList={ccyList} acList={acList} numList={numList} onSave={newOnSave} onCancel={() => { setCurrentMode("show"); changeTab(lastTabId) }}></ReceiptEdit>
            break
        case "copy":
            detail = <ReceiptEdit isNew svc={svc} currentEnv={currentEnv} ch={currentCH} ccyList={ccyList} acList={acList} numList={numList} onSave={newOnSave} onCancel={() => { setCurrentMode("show") }}></ReceiptEdit>
            break
    }

    let list = <>
        <div className="Row">
            <Button className="Col-1-1" icon="add" onClick={() => { setLastTabId(selectedTabId); setCurrentMode("new"); changeTab("detail") }}>{t('new')}</Button>
        </div>
        <div className="Spacing-V-16" />
        {isLoading && <Spinner></Spinner>}
        <HTMLTable striped interactive condensed>
            <thead>
                <tr>
                    <th className="TCol-Journal">{t('journal')}</th>
                    <th className="TCol-Voucher">{t('voucher')}</th>
                    <th className="TCol-Reference">{t('reference')}</th>
                    <th className="TCol-Date">{t('date')}</th>
                    <th className="TCol-PartyCode">{t('party_code')}</th>
                    <th className="TCol-ChequeNo">{t('cheque_no')}</th>
                    <th className="TCol-ACCode">{t('account')}</th>
                    <th className="TCol-ACName">{t('account_name')}</th>
                    <th className="TCol-ACBalance"><div className="Align-R">{t('amount')}</div></th>
                </tr>
            </thead>
            <tbody>
                {data.map((ch, i) =>
                    <tr key={i} onDoubleClick={() => { changeTab("detail") }}>
                        <td className="TCol-Journal" onClick={() => { setCurrentCH(ch) }}>{ch.journalCode}</td>
                        {/*<td className="TCol-Voucher" onClick={() => { setCurrentCH(ch) }}>{ch.voucherCode}</td>*/}
                        <td className="TCol-Voucher" onClick={() => { setCurrentCH(ch) }}><a target="_blank" href={`#/receipts/detail/${ch.journalCode}/${ch.voucherCode}`}>{ch.voucherCode}</a></td>
                        <td className="TCol-Reference" onClick={() => { setCurrentCH(ch) }}>{ch.reference}</td>
                        <td className="TCol-Date" onClick={() => { setCurrentCH(ch) }}>{ch.txDate}</td>
                        <td className="TCol-PartyCode" onClick={() => { setCurrentCH(ch) }}>{ch.partyCode}</td>
                        <td className="TCol-ChequeNo" onClick={() => { setCurrentCH(ch) }}>{ch.cheque}</td>
                        <td className="TCol-ACCode" onClick={() => { setCurrentCH(ch) }}>{ch.acCode}</td>
                        <td className="TCol-ACName" onClick={() => { setCurrentCH(ch) }}>{ch.acName}</td>
                        <td className="TCol-ACBalance" onClick={() => { setCurrentCH(ch) }}><div className="Align-R">{utils.formatMoney(Math.abs(ch.dr - ch.cr))}</div></td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
    </>

    return (
        <>
            <div style={{fontSize: "21px", fontWeight: 700}}>{t('receipts')}</div>
            <div className="Spacing-V-16"></div>
            <form onSubmit={onSubmit}>
                <div className="Row">
                    <FormGroup className="Col-1-3" label={t('search')} labelFor="inputSearchValue">
                        <ControlGroup fill>
                            <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                <option value="voucherCode">{t('journal')}</option>
                            </HTMLSelect>
                            <InputGroup
                                id="inputSearchValue"
                                placeholder={t('journal')}
                                readOnly
                                value={searchValue}
                                onChange={utils.handleStringChange(s => setSearchValue(s))}
                                leftIcon="search"
                            />
                            <InputGroup
                                id="inputSearchValue2"
                                placeholder={t('voucher')}
                                value={searchValue2}
                                onChange={utils.handleStringChange(s => setSearchValue2(s))}
                                rightElement={<Button icon={IconNames.ARROW_RIGHT} minimal type="submit"></Button>}
                            />
                        </ControlGroup>
                    </FormGroup>
                    {/*<Checkbox className="Col-4-1 Checkbox-LabeledFormGroup" label="Backward" defaultChecked={searchBackward} onChange={utils.handleBooleanChange(v => setSearchBackward(v))} />*/}
                    {/*<Button className="Col-5-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>*/}
                </div>
                <Collapse isOpen={showFilters}>
                    <div className="Row">
                        <FormGroup className="Col-1-1" label={t('from')} labelFor="searchFrom">
                            <InputGroup id="searchFrom" type="date" value={searchFrom} onChange={utils.handleStringChange(s => setSearchFrom(s))} />
                        </FormGroup>
                        <FormGroup className="Col-2-1" label={t('to')} labelFor="searchTo">
                            <InputGroup id="searchTo" type="date" value={searchTo} onChange={utils.handleStringChange(s => setSearchTo(s))} />
                        </FormGroup>
                        <FormGroup className="Col-3-1" label={t('reference')} labelFor="searchReference">
                            <InputGroup id="searchReference" value={searchReference} onChange={utils.handleStringChange(s => setSearchReference(s))} />
                        </FormGroup>
                        <FormGroup className="Col-4-1" label={t('party')} labelFor="searchParty">
                            <InputGroup id="searchParty" value={searchParty} onChange={utils.handleStringChange(s => setSearchParty(s))} />
                        </FormGroup>
                        {/*
                        <div className="Col-4-2 Col-H">
                            <FormGroup label="Limit" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup>
                        </div>
                        */}
                    </div>
                    {/*
                    <div className="Row">
                        <FormGroup className="Col-1-3" label={t('description')} labelFor="searchDesc">
                            <InputGroup id="searchDesc" value={searchDesc} onChange={utils.handleStringChange(s => setSearchDesc(s))} />
                        </FormGroup>
                    </div>
                    */}
                </Collapse>
            </form>
            <Tabs onChange={(newTabId) => changeTab(newTabId as string)} selectedTabId={selectedTabId}>
                <Tab id="list" title={t('list')} panel={list} />
                <Tab id="detail" title={t('detail')} panel={detail} />
            </Tabs>
        </>
    );
}

export default ReceiptMain